import { createFileRoute } from "@tanstack/react-router";

import { useSurface } from "../features/show/useSurface";
import { useCanvasState } from "../lib/useCanvasState";

/** The broadcast: the whole show, drawn by the activity's own surface module. */
export const Route = createFileRoute("/show/display/$stageMount")({
  component: ShowDisplay,
});

function ShowDisplay() {
  const { stageMount } = Route.useParams();
  const stage = useCanvasState(stageMount);
  const { canvas } = useSurface("panel_stage", "show", stage.state);

  return (
    <main style={{ position: "fixed", inset: 0, overflow: "hidden", background: "#0d0f1f" }}>
      <canvas ref={canvas} style={{ width: "100%", height: "100%", display: "block" }} />
    </main>
  );
}
